import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const host = window.location.hostname
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)
const ROOT_URL = (local || develop)
  ? 'https://myphoto-api-develop.appspot.com'
  : (staging)
    ? 'https://myphoto-api-staging.appspot.com'
    : 'https://mp-cloud-api.appspot.com'

const initialState = {
  results: [
    {
      name: null,
      triggerMinOrderAmt: 0,
      triggerMinQty: 0,
      triggerByProduct: false,
      triggerAllProducts: false,
      triggerProducts: [],
      triggerByItem: false,
      triggerAllItems: false,
      triggerItems: [],
      discountType: null,
      discountValue: 0,
      discountPercent: 0,
      discountLimitQty: 0,
      discountProducts: [],
    },
  ],
  discount: {
    name: null,
    triggerMinOrderAmt: 0,
    triggerMinQty: 0,
    triggerByProduct: false,
    triggerAllProducts: false,
    triggerProducts: [],
    triggerByItem: false,
    triggerAllItems: false,
    triggerItems: [],
    discountType: null,
    discountValue: 0,
    discountPercent: 0,
    discountLimitQty: 0,
    discountProducts: [],
    discountItems: [],
  },
  viewDiscount: false,
  meta: {
    count: 0,
    totalCount: 0,
    pageCount: 0,
    self: `${ROOT_URL}/discounts?page=1`,
    previous: null,
    next: null,
    first: null,
    last: null,
    page: 1,
    limit: 20,
  },
};

function discounts(state = initialState, action) {
  switch (action.type) {
    case types.DISCOUNTS_FETCH_SUCCESS:
      return assign({}, state, action.res);
    case types.DISCOUNTS_FETCH_ERROR:
    case types.DISCOUNT_FETCH_ERROR:
    case types.DISCOUNT_EDIT_ERROR:
    case types.DISCOUNT_SET_ERROR:
    case types.DISCOUNT_DISABLE_ERROR:
      return assign({}, state, {
        error: action.res,
      });
    case types.DISCOUNT_FETCH_SUCCESS:
    case types.DISCOUNT_EDIT_SUCCESS:
    case types.DISCOUNT_SET_SUCCESS:
      return assign({}, state, {
        discount: action.res,
      });
    // case types.VIEW_DISCOUNT:
    //   return assign({}, state, {
    //     viewDiscount: action.res,
    //   });
    case types.DISCOUNT_DISABLE_SUCCESS:
      return assign({}, state, {
        discountDisabled: action.res.ok,
      });
    case types.DISCOUNT_DELETE_SUCCESS:
      return assign({}, state, {
        discountDelete: action.res.ok,
      });
    case types.DISCOUNTS_CLEAR_ERRORS:
    case types.DISCOUNT_CLEAR_ERRORS:
      return assign({}, state, {
        error: false,
      });
    default:
      return state;
  }
}

export default discounts;



// WEBPACK FOOTER //
// ./src/reducers/discounts.js